import React from "react";
import MentorPricingForm from "../forms/MentorPricingForm.jsx";
import ScheduleTimings from "./ScheduleTimings.jsx";
import CommonDropdown from "../commonDropDown/CommonDropDown.jsx";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../customButtom/CustomButton.jsx";
import { api1 } from "../../utils/axiosInstance.js";
import { toast } from "react-toastify";
import { getProfile } from "../../services/mentorProfile.js";
import WelcomeCard from "../WelcomeCard";

const ScheduleTimingComponent = () => {
  const dispatch = useDispatch();
  const mentorProfile = useSelector((state) => state.mentor.profile);
  const timezones = Intl.supportedValuesOf("timeZone").map((tz) => ({
    value: tz,
    label: tz,
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { timezone: mentorProfile.timezone } });

  const onSubmit = async (data) => {
    try {
      await api1.put("/api/mentorProfile/update-timezone", {
        userId: mentorProfile.id,
        timezone: data.timezone,
      });
      dispatch(getProfile({ userId: mentorProfile.id }));

      toast.success("Timezone Updated");
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <WelcomeCard title={"Schedule Timings"} />

      <div className=" flex flex-col gap-4 mt-5">
        <form
          className="flex flex-col sm:flex-row items-end gap-3 bg-white p-5 rounded-md shadow-md"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="w-full mb-3 sm:mb-0">
            <CommonDropdown
              label="Time zone"
              name="timezone"
              required
              register={register}
              errors={errors}
              search={true}
              defaultValue={mentorProfile?.timezone}
              options={timezones}
            />
          </div>
          <div className="w-full sm:w-auto">
            <CustomButton
              type="submit"
              label={"Submit"}
              width="w-full flex justify-center"
            />
          </div>
        </form>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <ScheduleTimings />
        </div>
      </div>
    </>
  );
};

export default ScheduleTimingComponent;
